/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

import { Checkbox, HStack, Text } from '@chakra-ui/react'
import { tooltipQuestion } from '@zcode-ui/icons'
import { PopoverTooltip } from '@zcode-ui/web-zumper-ui'
import React, { type ChangeEvent, useCallback } from 'react'

import {
  ALERT_CHECKBOX_FORM_NAME,
  DLC_CHECKBOX_TEXT,
  MM_PREVENT_CHECKBOX_TEXT,
  TOOLTIP_TEXT,
  TOOLTIP_TEXT_MM_PREVENT,
} from '../constants'

export interface AlcCheckboxProps {
  onChange: (isChecked: boolean) => void
  isChecked: boolean
  isMmPrevent?: boolean
}

export const AlcCheckbox = ({ onChange, isChecked, isMmPrevent }: AlcCheckboxProps) => {
  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      event.preventDefault()
      onChange(event.target.checked)
    },
    [onChange]
  )

  return (
    <Checkbox
      alignItems="self-start"
      isChecked={isChecked}
      name={ALERT_CHECKBOX_FORM_NAME}
      onChange={handleOnChange}
      size="lg"
    >
      <HStack<'div'> spacing={1}>
        <Text as="span" color="gray.950" display="inline-block" fontSize="sm">
          {isMmPrevent ? MM_PREVENT_CHECKBOX_TEXT : DLC_CHECKBOX_TEXT}
        </Text>
        <PopoverTooltip
          buttonProps={{
            minWidth: 'auto',
          }}
          hasArrow={false}
          label={isMmPrevent ? TOOLTIP_TEXT_MM_PREVENT : TOOLTIP_TEXT}
          popoverContentProps={{
            marginLeft: { base: 6, md: 0 },
            marginRight: { base: 6, md: 0 },
            marginTop: 2,
          }}
        >
          <img alt="" height={16} src={tooltipQuestion} width={16} />
        </PopoverTooltip>
      </HStack>
    </Checkbox>
  )
}
